// https://imageboss.me/docs
const IMAGEBOSS_BASE = "https://img.imageboss.me"
const IMAGEBOSS_NAME = "grupoacelerador"
const CDN_PREFIX = `${IMAGEBOSS_BASE}/${IMAGEBOSS_NAME}/cdn/`
const IMAGEBOSS_PREFIX = `${IMAGEBOSS_BASE}/${IMAGEBOSS_NAME}/`

// Substitui qualquer operação (width/N/, cover:mode/WxH/) por cdn para servir o original
export const imagebossOriginal = (url: string | null | undefined): string | null => {
  if (!url) return null
  if (!url.startsWith(IMAGEBOSS_PREFIX)) return url
  const afterPrefix = url.slice(IMAGEBOSS_PREFIX.length)
  const withoutOp = afterPrefix.replace(/^(?:width\/\d+|cover:[^/]+\/\d+x\d+|cdn)\//, "")
  return `${IMAGEBOSS_PREFIX}cdn/${withoutOp}`
}

// Substitui o width de uma URL já transformada pelo imageboss
export const imagebossSetWidth = (url: string | null | undefined, width: number): string | null => {
  const cdnUrl = imagebossOriginal(url)
  if (!cdnUrl) return null
  return imagebossWidth(cdnUrl, width)
}

const extractPath = (url: string): string | null => {
  if (!url.startsWith(CDN_PREFIX)) return null
  return url.slice(CDN_PREFIX.length)
}

// https://img.imageboss.me/{source}/width/{pixels}/{path}
export const imagebossWidth = (url: string | null | undefined, width: number): string | null => {
  if (!url) return null
  const path = extractPath(url)
  if (!path) return url
  return `${IMAGEBOSS_BASE}/${IMAGEBOSS_NAME}/width/${width}/${path}`
}

// https://img.imageboss.me/{source}/cover:{mode}/{WxH}/{path}
export const imagebossCover = (
  url: string | null | undefined,
  width: number,
  height: number,
  mode: "smart" | "face" | "attention" | "entropy" | "center" = "smart"
): string | null => {
  if (!url) return null
  const path = extractPath(url)
  if (!path) return url
  return `${IMAGEBOSS_BASE}/${IMAGEBOSS_NAME}/cover:${mode}/${width}x${height}/${path}`
}
